import * as types from "../type/type";

export const setAccount = (account) => ({
  type: types.SET_ACCOUNT,
  payload: account,
});
